import { render, staticRenderFns } from "./LinkWidget.vue?vue&type=template&id=ce69ff72&scoped=true&"
import script from "./LinkWidget.vue?vue&type=script&lang=js&"
export * from "./LinkWidget.vue?vue&type=script&lang=js&"
import style0 from "./LinkWidget.vue?vue&type=style&index=0&id=ce69ff72&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce69ff72",
  null
  
)

export default component.exports